import IconWithLabel from "web-library/stories/atom/IconWithLabel/IconWithLabel";
import { IconName } from "web-library/stories/atom/Icon/Icon";
import React from "react";
import { IStylingAndTranslationHooks } from "./model";

const UploadingInProgressVisualLabel = ({
                                          classes,
                                          translation: t,
                                        }: IStylingAndTranslationHooks) => (
  <IconWithLabel
    className={classes.uploadingIcon}
    iconName={IconName.loadingIndicator}
    iconSize="M"
    label={t('exam->>UploadExcelTemplate.UploadingInProgressDescription')}
    typographyProps={{
      variant: 'h5',
      color: 'inherit',
    }}
  />
);

export {
  UploadingInProgressVisualLabel
}
